import React, { useEffect, useState } from 'react';
import { SplashScreen } from '@capacitor/splash-screen';
import { isNativePlatform } from '../../utils/platform';
import iconBlack from '../../images/icon_black.png';

const SplashAnimation = ({ onRotationEnd }: { onRotationEnd: () => void }) => {
  const [dismissing, setDismissing] = useState(false);

  useEffect(() => {
    if (isNativePlatform()) SplashScreen.hide({ fadeOutDuration: 0 });
    // Fallback: start fade if the rotation animationend never fires (e.g. prefers-reduced-motion, browser animation disabled, or the element being hidden)
    const fallback = setTimeout(() => setDismissing(true), 800);
    return () => clearTimeout(fallback);
  }, []);

  return (
    <div
      className={`splash-boot-container${dismissing ? ' splash-dismissing' : ''}`}
      onAnimationEnd={(e) => {
        if (e.animationName === 'splash-fade-out') onRotationEnd();
      }}
    >
      <img
        src={iconBlack}
        alt=""
        onAnimationEnd={(e) => {
          if (e.animationName === 'splash-rotate-center') {
            e.stopPropagation();
            setDismissing(true);
          }
        }}
      />
    </div>
  );
};

export default SplashAnimation;
